<script setup lang="ts">
import PharmacistCertificationModal from "@/customer/components/PharmacistCertificationModal.vue";
import {onMounted, ref} from "vue";
import {useSystemStore} from "@/stores/system.store";
import Customer from "@/customer/interfaces/Customer";
import {customerApi} from "@/container";
import {storeToRefs} from "pinia";
import ApplicationMobileTutorialModal
    from "@/customer/components/application-mobile/application-mobile-tutorial-modal/ApplicationMobileTutorialModal.vue";

const {environment} = storeToRefs(useSystemStore());
const healthcenterCustomers = ref<Customer[]>([]);
const loading = ref(false);

onMounted(() => {
    if (environment.value?.user) {
        loading.value = true;
        customerApi().find({
            first_name: environment.value.user.given,
            last_name: environment.value.user.familyBirth
        })
            .then(response => {
                healthcenterCustomers.value = response;
            })
            .finally(() => {
                loading.value = false;
            });
    }
});
</script>

<template>
  <div class="relative flex flex-row gradient pt-4 pb-12">
    <div class="flex flex-col w-[90%] pl-4">
      <h2 class="text-white pl-1">
        Une application gratuite pour vos patients
      </h2>
      <p class="text-neutral pl-1">
        Sur l'application Apodis, votre patient retrouvera toute votre pharmacie dans sa poche ! Ses
        ordonnances,
        son suivi vaccinal, votre vitrine click&collect, et bien plus encore !
      </p>
    </div>
    <ApplicationMobileTutorialModal>
      <div class="absolute flex flex-row right-28 bottom-1 items-center cursor-pointer hover:opacity-80">
        <span class="font-bold text-secondary">👀 Découvrir l'app</span>
      </div>
    </ApplicationMobileTutorialModal>
    <PharmacistCertificationModal :customers="healthcenterCustomers" :loading="loading">
      <div
        class="absolute flex flex-row right-72 bottom-1 items-center cursor-pointer hover:opacity-80"
      >
        <span class="font-bold text-secondary">🤚 Essayer l'app</span>
      </div>
    </PharmacistCertificationModal>
    <img
      alt="iphone mockup"
      class="absolute right-2 -bottom-1 h-28"
      src="@/assets/images/iphone-mockup.png"
    >
  </div>
</template>

<style scoped>

</style>
